import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { createVariable, getVariables, toggleVariableActive, updateVariable } from "../../../api/variables";
import { VariablesTable } from "../../../components/Variables";
import { useErrorHandler } from "../../../hooks/Error/useErrorHandler";
import { setLoading } from "../../../store/UI";
import { CreateVariableRequest, UpdateVariableRequest, VariableResponse } from "../../../types/model/variable";

const Variables: React.FC = () => {
  const [variables, setVariables] = useState<VariableResponse[]>([]);
  const dispatch = useDispatch();
  const handleError = useErrorHandler();
  
  const fetchVariables = async () => {
    try {
      dispatch(setLoading(true));
      const data = await getVariables(true);
      setVariables(data);
    } catch (error) {
      handleError(error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    fetchVariables();
  }, []);

  const handleCreate = async (values: CreateVariableRequest) => {
    await createVariable(values);
    fetchVariables();
  };

  const handleUpdate = async (variableId: number, values: UpdateVariableRequest) => {
    await updateVariable(variableId, values);
    fetchVariables();
  };

  const handleToggleActive = async (variableId: number) => {
    try {
      await toggleVariableActive(variableId);
      setVariables(prevVariables =>
        prevVariables.map(variable =>
          variable.id === variableId
            ? { ...variable, active: !variable.active }
            : variable
        )
      );
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <VariablesTable
      variablesData={variables}
      onCreate={handleCreate}
      onUpdate={handleUpdate}
      onToggleActive={handleToggleActive}
      onRefresh={fetchVariables}
    />
  );
};

export default Variables;